'use strict';
import request from '@/utils/request';
class ExperiencesService{
    static getexperiences(query){
        return request({
            url:'/experiences/getexperiences',
            method:'get',
            params:query
        })
    }
    static createexperiences(data){
        return request({
            url:'/experiences/createexperiences',
            method:'post',
            data
        })
    }
    static editexperience(data){
        return request({
            url:'/experiences/editexperience',
            method:'put',
            data
        })
    }
    static deleteexperience(query){
        return request({
            url:'/experiences/deleteexperiences',
            method:'delete',
            params:query
        });
    }
}

export default ExperiencesService
